import { render, staticRenderFns } from "./RoomBoxFooter.vue?vue&type=template&id=79e60aca&"
import script from "./RoomBoxFooter.vue?vue&type=script&lang=js&"
export * from "./RoomBoxFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports